import { Routes } from '@angular/router';

const routes: Routes = [
    {
        path: 'privacy',
        loadComponent: () => import('@stair-craft/legal/privacy'),
        data: {
            breadcrumb: $localize`:@@breadcrumbPrivacy:Политика конфиденциальности`,
            seoTitle: $localize`:@@seoPrivacyTitle:Политика конфиденциальности — GoldenCalc`,
            seoDescription: $localize`:@@seoPrivacyDesc:Какие данные собирает онлайн-конструктор лестниц GoldenCalc, зачем они нужны, где хранятся и как вы можете ими управлять.`,
        },
    },
    {
        path: 'terms',
        loadComponent: () => import('@stair-craft/legal/terms'),
        data: {
            breadcrumb: $localize`:@@breadcrumbTerms:Пользовательское соглашение`,
            seoTitle: $localize`:@@seoTermsTitle:Пользовательское соглашение — GoldenCalc`,
            seoDescription: $localize`:@@seoTermsDesc:Условия использования бесплатного онлайн-конструктора деревянных лестниц GoldenCalc: права, ответственность и ограничения расчётов.`,
        },
    },
    {
        path: 'cookies',
        loadComponent: () => import('@stair-craft/legal/cookies'),
        data: {
            breadcrumb: $localize`:@@cookiesTitle:Cookies`,
            seoTitle: $localize`:@@seoCookiesTitle:Cookies — GoldenCalc`,
            seoDescription: $localize`:@@seoCookiesDesc:Какие cookies использует конструктор лестниц GoldenCalc — обязательные и аналитические, — зачем они нужны и как ими управлять.`,
        },
    },
];

export default routes;
